<template>
  <div>
    <div :style="colorbackground" class="container-fluid login">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-10 col-sm-8 mx-auto login-form">

            <router-link to="/" class="content-logo-principal">
              <div class="style-scope page-auth-login" style="display:flex;justify-content:center;align-items:center">
                <h1 class="logo-name style-scope page-auth-login">
                  <a href="https://royalpag.com">
                    <img :src="img" style="width: 250px">
                  </a>
                </h1>
              </div>
            </router-link>
            <h2 class="text-center text-default-gray" style="font-size: 16px; font-family: Roboto; margin-bottom: 20px !important;">
              Bem-vindo ao RoyalPag
            </h2>
            <p class="text-center text-default-gray pt-2" style="font-size: 14px; font-family: Roboto;">Desenhado e criado para proporcionar agilidade e segurança para você.</p>
            <p class="text-center text-default-gray" style="font-size: 14px; font-family: Roboto; margin-bottom: 0px !important;">Entrar para obter!</p>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-12">
                  <form class="well top25" @submit.prevent="doLogin">
                    <div class="form-group">
                      <input v-model="login" name="login" type="text" autocomplete="username" required autofocus placeholder="Login" class="form-control"/>
                    </div>
                    <div class="form-group">
                      <input v-model="senha" name="senha" type="password" autocomplete="current-password" required autofocus placeholder="Senha" class="form-control"/>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <input type="submit" value="Entrar" :style="color" class="btn btn-primary btn-block mb-3"/>
                      </div>
                      <div class="col-sm-6">
                        <router-link to="/forgotPassword" class="float-left" exact >Esqueceu a senha? </router-link>
                      </div>
                      <div class="col-sm-6">
                        <span class="float-right sign-up">Novo?  <router-link to="/register" exact>Cadastrar</router-link></span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="col-sm-10 pt-2 pl-0">
                          <router-link to="/verificar" class="float-left" exact>Verificar código recebido?</router-link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
               <b-modal id="modalConfirmTelefone" v-model="showModalTelefone" ref="modalTelefone" class=" modal" style="min-width: max-content !important; display: none;" title="Atualização do telefone" @hide="closeModalTelefone">
                <div class="modal-dialog" role="form"  style="min-width: max-content !important; ">
                </div>
              </b-modal>
              <b-modal id="modalConfirmTelefone" v-model="showModalTelefone" ref="modalTelefone" class="pb-0" style="min-width: max-content !important; display: inline-table;" title="Atualização do telefone" role="form" no-close-on-esc no-close-on-backdrop hide-footer>
                <div class="align-content-center content p-0"  style="min-width: max-content !important;">
                   <div>
                    <div>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="card">                           
                            <div class="card-body">
                              <div class="asterisco">
                                <label class="font-label text-default-gray" >Confirme seu número de celular, um SMS com código será enviado</label>                                
                              </div>
                              <form @submit.prevent="confirmarCelular">
                                <div class="form-group">
                                  <div>                                
                                    <vue-phone-number-input 
                                      v-model="telefone"  
                                      :preferred-countries="['BR','PT']" 
                                      :default-country-code="'BR'" :translations="translations" maxlength="18" 
                                      @update="onUpdate"></vue-phone-number-input>
                                  </div>
                                </div>
                                <div class="form-group margin-bottom-0">
                                  <button name="submit" type="submit" class="btn btn-success">Enviar SMS</button>                                  
                                </div>                               
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                   </div>
                </div>
              </b-modal>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import http from '@/service/http'
  import site_style from '@/service/site_style'
  import localforage from 'localforage'
  import { mapActions, mapGetters, mapState } from 'vuex'
  import VueToast from 'vue-toastr-2/src/toastr.min'
  import telefon_token from '@/service/telefon_token'
  
  export default {
    name: 'Authentication',
    computed: {
      ...mapGetters(['role', 'getIt']),
      ...mapState(['logo']),
      ...mapGetters(['getIpClient']),
    },
    mounted () {
      localforage.removeItem('I-INA-SYSTEM-AUTH')
      localforage.removeItem('I-INA-SYSTEM')
    },
    data () {
      return {
        img: site_style.getLogo().default,
        color: site_style.getColor(),
        colorbackground: site_style.  getColorBackGround(),
        translations: {
          countrySelectorLabel: 'Selecione um País',
          example: 'Exemplo :',
          countrySelectorError: 'País invalido',
          phoneNumberLabel: 'Celular'
        },
        bindProps: {
          defaultCountry: 'BR',
          disabledFetchingCountry: false,
          disabled: false,
          disabledFormatting: false,
          placeholder: 'Informe seu telefone',
          required: true,
          enabledCountryCode: false,
          enabledFlags: true,
          preferredCountries: ['BR'],
          onlyCountries: [],
          ignoredCountries: [],
          autocomplete: 'off',
          name: 'telephone',
          maxLen: 25,
          wrapperClasses: '',
          inputClasses: 'telClass',
          dropdownOptions: {
            disabledDialCode: false
          },
          inputOptions: {
            showDialCode: false
          }
        },
        login: '',
        senha: '',
        ipCliente: '',
        showModalTelefone: false,
        telefone: '',
        jsonInputTelefone: '',
        response: null
      }
    },
    methods: {
      ...mapActions(['setToken', 'setMenu']),
      ...mapActions('auth', ['setUsuario', 'loginFirebase']),
      showToast (obj) {
        const toast = VueToast
        const verb = obj.verb
        const message = obj.message
        const title = obj.title
        const options = obj.options
        this.$store.dispatch('toast', {verb, message, title, options, toast})
      },
      async doLogin () {

        this.response = null
        this.telefone = ''
        this.ipCliente = JSON.stringify(this.getIpClient);
        
        const {login, senha, ipCliente} = this
 
        const response = await http.post(
          '/login',
          {login, senha, ipCliente}
        )
        this.showModalTelefone = false

        if (response.status === 200) {
          this.response = response

          // var id = this.response.data.data.id.toString();
 
          // var md5Key = telefon_token.getMD5(id)
          // var token = telefon_token.getCookie(`ROYALPAG_TELEFON_TOKEN_${id}`)
  
          // if(this.response.data.data.descricaoTipoUsuario == "ADMINISTRADOR" && token != md5Key) {

          //     var data  = {
          //       telefone: this.response.data.data.telefone,
          //       email: this.response.data.data.login,
          //       key: '-'
          //     };

          //     this.confirmarCelularADM(data)
          //     return false;
          // }

          if (this.$socket.disconnected) {
            this.$socket.connect(process.env.API_URL_SOCKET,  { resource: 'message/socket.io' })
          }
          console.log('autenticarFirebase: ' + response.data.data.autenticarFirebase)
          var errorCode = 0
          if (response.data.data !== undefined && response.data.data.autenticarFirebase) {
            var error = null
            error = await this.loginFirebase({login, senha})
            if (error.code !== undefined) {
              errorCode = 2
            }
            console.log('errorCode: ' + errorCode)
            if (errorCode === 0) {
              this.showModalTelefone = true
              if (response.data.data.telefone !== undefined) {
                this.telefone = response.data.data.telefone
              }
              if (response.data.data.fotoVerificada === true) {
                this.showModalTelefone = false
              }
            } else {
              this.showToast({verb: 'error', message: 'Usuário ou senha inválida', title: 'Falha no Login', options: null})
            }
          }
          if (!this.showModalTelefone && errorCode === 0) {

          
            const {token} = response.data.data
            localforage.setItem('vpUser', response.data.data.id)
            localforage.setItem('unreadMessagesArquivadas', [])
            localforage.setItem('unreadMessages', [])
            localforage.setItem('googleAuthenticatorQRCode', response.data.data.googleAuthenticatorQRCode)
            localforage.setItem('token', token).then((token) => {
              this.setMenu(response.data.data.menu.data)
              this.setToken({token})
              this.setUsuario(response.data.data.id) // setando o usuario
              console.log('role: ' + this.role)
              if (this.role !== null) {
               this.$router.push({name: 'vp.index'})
              }
            })
          }
        }
        else{
          
          if(response.data.message == "Telefone não verificado.") {
             this.showModalTelefone = true;
             
          } else if(response.data.message == "Codigo inválido.") {
            
             this.$router.push({ name: 'auth.verificacaogoogle', params: { tipo: "ADMINISTRADOR", login: login, senha: senha, ipCliente: ipCliente  }})
          }
        }
      },
       async confirmarCelularADM (data) {
  
        const responseSms = await http.post('/usuario/solicitarNovoCodigoSmsVerificacao', data)

 
        if (responseSms.data.code === 200) {
 
          if(response.data.message == "Telefone não verificado.") {

             this.showModalTelefone = true;
             
          }
 
           localforage.setItem('I-INA-SYSTEM-AUTH',  this.response.data.data.token)
           localforage.setItem('I-INA-SYSTEM',  this.response.data.data.token)

           this.$router.push({ name: 'auth.verificacao', params: { tipo: this.response.data.data.descricaoTipoUsuario }  })
           //this.$router.push({ name: 'auth.verificacao', params: { tipo: 'ADMINISTRADOR' }  })
         
        }
      },
      async confirmarCelular () {
        const telefoneFormatInternational = this.jsonInputTelefone['formatInternational']
        const countryCode = this.jsonInputTelefone['countryCode']
        const nationalNumber = this.jsonInputTelefone['nationalNumber']
        const formattedNumber = this.jsonInputTelefone['formattedNumber']
  
        var data  = {
          paisTelefone: countryCode,
          telefone: telefoneFormatInternational ,
          codigoPaisTelefone: formattedNumber.replace(nationalNumber, ''),
          email: this.login,
          key: '-'
         };
 
        const responseSms = await http.post('/usuario/solicitarNovoCodigoSmsVerificacao', data)
        if (responseSms.data.code === 200) {
 
             if(this.response) {

 
                 localforage.setItem('I-INA-SYSTEM-AUTH',  this.response.data.data.token)
                 localforage.setItem('I-INA-SYSTEM',  this.response.data.data.token)
                  
                 this.$router.push({ name: 'auth.verificacao', params: { tipo: this.response.data.data.descricaoTipoUsuario }  })
             }
             else {
 
                 localforage.setItem('I-INA-SYSTEM-AUTH',  responseSms.data.data.token)
                 localforage.setItem('I-INA-SYSTEM',  responseSms.data.data.token)
                  
                 this.$router.push({ name: 'auth.verificacao', params: { tipo: responseSms.data.data.descricaoTipoUsuario }  })
             }         
 
        }
      },
      closeModalTelefone () {
        // this.modalUserShow = false
        this.$refs.modalTelefone.hide()
      },
      onUpdate (payload) {
        this.jsonInputTelefone = payload
      }
    }
  }
</script>

<style src="../../assets/css/login.css" scoped></style>
<style scoped>
  .logo-name.page-auth-login {
    letter-spacing: -10px;
    margin-bottom: 0px;
    margin-top: 0;
  }
  .top25 {
    margin-top: 25px;
  }
  .login {
    padding-top: 6.5%;
    padding-bottom: 2%;
    width: 100%;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* background: radial-gradient(ellipse at center, #5A93AF 0%, #004E74 100%); */
    background-color: #eee;
    overflow-y: auto;
  }
  .submit-btn {
    background-color: rgba(255,255,255, .2);
  }
  .font-label {
    font-family: Roboto;
    font-size: 14px;
    margin-bottom: 0px;
    letter-spacing: 0px;
  }
  .modal-body{
    padding: 0.2rem;
  }
</style>




// WEBPACK FOOTER //
// index.vue?1a8d6a4a